export default "__VITE_ASSET__CwaHjIsl__"